import { api } from '@fastcampus/browser-support';

const config = {
  headers: { 'cache-control': 'no-cache', Pragma: 'no-cache' },
};

export default {
  async getPopups(slug = '') {
    try {
      return api.get(`/popups/expose?site=FASTCAMPUS&slug=${slug}`, config);
    } catch (err) {
      throw err;
    }
  },
  async requestCouponsByPopupId(id) {
    try {
      return api.put(`/popups/redeems/${id}`);
    } catch (err) {
      throw err;
    }
  },
  async getPopupCustomers(id) {
    try {
      return api.get(`/popup_customers/${id}`, config);
    } catch (err) {
      throw err;
    }
  },
};
